<template>
  <form class="form" @submit.prevent="submit">
    <h2>{{ $t('profile.TITLE') }}</h2>
    <label>{{ $t('profile.label.EMAIL') }}
      <input class="form-input" disabled type="text" autocomplete="username" :value="user.email">
    </label>
    <div class="settings-section">
      <h3>{{ $t('profile.section.CHANGE_PASSWORD') }}</h3>
      <BaseInput
        :label="$t('profile.label.OLD_PASSWORD')"
        :placeholder="$t('profile.OLD_PASSWORD_PLACEHOLDER')"
        :errors="errors.old_password"
        v-model="oldPassword"
        type="password"
        autocomplete="current-password"
      />
      <BaseInput
        :label="$t('profile.label.PASSWORD')"
        :placeholder="$t('profile.PASSWORD_PLACEHOLDER')"
        :errors="errors.new_password"
        v-model="newPassword"
        type="password"
        autocomplete="new-password"
      />
      <BaseInput
        :label="$t('profile.label.PASSWORD2')"
        :placeholder="$t('profile.PASSWORD2_PLACEHOLDER')"
        :errors="errors.new_password2"
        v-model="newPassword2"
        type="password"
        autocomplete="new-password"
      />
    </div>
    <div v-if="errors.form.length" class="errors-container">
      <ul>
        <li class="error" v-for="error in errors.form" :key="error">{{ error }}</li>
      </ul>
    </div>
    <div class="submit-container">
      <input class="primary-button" type="submit" :value="$t('profile.SUBMIT_BUTTON')">
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { unpackDetails } from '@/utils/utils.format'

export default {
  name: 'UserProfile',
  data () {
    return {
      oldPassword: '',
      newPassword: '',
      newPassword2: '',
      errors: this.newErrors()
    }
  },
  methods: {
    newErrors () {
      return {
        form: [],
        old_password: [],
        new_password: [],
        new_pasword2: []
      }
    },
    checkForm () {
      this.errors = this.newErrors()

      if (this.newPassword !== this.newPassword2) {
        this.errors.form.push(this.$t('profile.error.PASSWORD_MISMATCH'))
      }

      return !this.errors.form.length
    },
    submit () {
      const formValid = this.checkForm()

      if (formValid) {
        const payload = {
          old_password: this.oldPassword,
          new_password1: this.newPassword,
          new_password2: this.newPassword2
        }

        const changePasswordPromise = this.changePassword(payload)

        this.$awn.async(
          changePasswordPromise,
          this.onChangeSuccess,
          this.onChangeFailure,
          this.$t('profile.awn.SEND_FORM')
        )
      }
    },
    onChangeSuccess () {
      this.$awn.success(this.$t('profile.awn.SUCCESS'))
      this.reset()
    },
    onChangeFailure (error) {
      const details = error.response?.data || {}

      unpackDetails(this.errors, details)

      this.$awn.alert(this.$t('profile.awn.FAILURE'))
    },
    reset () {
      this.oldPassword = ''
      this.newPassword = ''
      this.newPassword2 = ''
    },
    ...mapActions(['changePassword'])
  },
  computed: mapState(['user'])
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

.form > h3 {
  font-weight: lighter;
  margin-top: 5px;
  text-align: center;
}

.settings-section {
  margin-bottom: 20px;

  h3 {
    padding-bottom: 5px;
    margin-bottom: 15px;
    border-bottom: $text-secondary 1px solid;
  }
}
</style>
